import { instance } from "../axios/axiosConfig";
import { BrandAsset } from "../types/brandAssetsTypes";

type FetchAssetsResponse = {
  results: Array<{
    id: number;
    name: string | null;
    image: string | null;
    thumbnail_url: string | null;
  }>;
  count: number;
};

const brandAssetsApi = {
  fetchBrandAssets() {
    return instance
      .get<FetchAssetsResponse>("/api/asset-library/assets/", {
        params: {
          page: 1,
          page_size: 200,
        },
      })
      .then((response) => {
        const assets: BrandAsset[] = response.data.results.map((asset) => ({
          id: asset.id,
          name: asset.name ?? "",
          image: asset.image ?? asset.thumbnail_url ?? "",
        }));

        return assets;
      });
  },
};

export default brandAssetsApi;
